export default "__VITE_ASSET__C_$1Q08d__"